import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './slider.css';

const ClientSlider = () => {
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    beforeChange: (current, next) => {
      setActiveIndex(next);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const clients = [
    {
      image: "assets/client/noursih-logo.png",
      heading: "Custom Website for Nourishment for Needy NGO",
      description: "A user-friendly website designed for Nourishment for Needy NGO, featuring a 'Donate Now' button, volunteer forms, success stories, and contact info.",
    },
    {
      image: "assets/client/client-06.png",
      heading: "Static Website",
      description: "A custom eCommerce website for your nighttime bed business, with responsive design, secure payments, fast load times, and integrated SEO.",
    },
    {
      image: "assets/client/client-04.png",
      heading: "Dynamic Startup Website for Formconnect",
      description: "A dynamic website for startups, with essential features like contact info, service listings, and interactive forms.",
    }
  ];


  return (
    <div className="client-slider">

      <Slider ref={sliderRef} {...settings}>
        {clients.map((client, index) => (
          <div key={index} className={`client-card ${index === activeIndex ? 'active' : ''}`}>
            <img
              src={client.image}
              alt={`Client project: ${client.heading}`}
              className="client-image"
            />
            <h3 className="h-hide">{client.heading}</h3>
            <div className={`client-content ${index === activeIndex ? 'show' : ''}`}>
              <h5>{client.heading}</h5>
              <p>{client.description}</p>
            </div>
          </div>
        ))}
      </Slider>

    </div>
  );
};

export default ClientSlider;
